<template>
    <EditModal
        id="notenfehlbuchungSVModal"
        title="Fehlbestand buchen"
        :busy="busy"
        size="md"
        buttonText="Buchen"
        buttonVariant="warning"
        scrollable
        :centered="true"
        @ok="dataProvide"
    >
        <template v-if="record">
            Sollen für
            <i>{{getNotenDescription(record.werk, record.komponist, record.ausgabe, record.notentyp)}}</i> die fehlenden
            <b>{{record.total}} Noten als Fehlbestand abgeschrieben werden</b> und der Notentransfer damit
            <b>abgeschlossen</b> werden?
        </template>
    </EditModal>
</template>

<script>
import EditModal from "@/components/EditModal/EditModal";
import Toaster from "@/mixins/Toaster/Toaster";
import NotenverwaltungCommon from "@/mixins/NotenverwaltungCommon/NotenverwaltungCommon";

export default {
    name: "NotenfehlbuchungSVModal",
    mixins: [Toaster, NotenverwaltungCommon],
    components: { EditModal },
    props: ["record", "busy"],
    methods: {
        async dataProvide(evt) {
            evt.preventDefault();
            this.$emit("success", {
                sv_id: this.record.sv_id,
                werk_id: this.record.werk_id,
                noten_id: this.record.noten_id,
                notentyp: this.record.notentyp,
                error_entry: true
            });
        }
    }
};
</script>